module.exports = __webpack_public_path__ + "img/check-mark.4ad279a9.svg";